import { supabase } from './supabase';

export async function signInWithOAuth(provider: 'google' | 'kakao'): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: `${window.location.origin}/auth/callback`,
    },
  });
  if (error) throw error;
}
